import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c0be6cb"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = { key: 1 }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "centre-text" }
const _hoisted_10 = ["onClick"]

import { ref, computed } from "vue";
import BaseContractPage from "./BaseContractPage.vue";
import { contractHireAgreements } from "@/services/network";

import IContractPageExpose from '@/Interfaces/components/IContractPageExpose';
import IHireAgreement from "@/Interfaces/Contract/IHireAgreement";
import ICustomerTermsConsent from "@/Interfaces/Contract/ICustomerTermsConsent";
import HireAgreementPopUp from "@/components/HireAgreementPopUp.vue";
import { marketSelection } from "@/services/helpers/Helper"; 
import PdfDownloadSign from '@/components/svg/PdfDownloadSign.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ContractHireAgreement',
  setup(__props) {

const basePage = ref<IContractPageExpose<IHireAgreement>>();

    const colsGB: (keyof IHireAgreement)[] = [
    'contractID',
    'customerID',
    'orderID',
    'market',
    'status',
    'hasFileData',
    'initialDate',
    'activationDate',
    'terminationDate'
];
const colsSE: (keyof IHireAgreement)[]  = [
    'contractID',
    'customerID',
    'orderID',
    'market',
    'status',
    'backbookConfirmation',
    'orderConfirmation',
    'orderChange',
    'contractChange',
    'initialDate',
    'activationDate',
    'terminationDate',
    't&CConsented'
];
const cols = computed<(keyof IHireAgreement)[]>(()=>
    marketSelection.value == 'GB' ? colsGB : colsSE
);

const secondaryTableData = ref<ICustomerTermsConsent[]>();  
function displayTablePopUp(data: ICustomerTermsConsent[]) {
    secondaryTableData.value = data;
}
async function contractGetAPI(data) {
    const res = await contractHireAgreements.get(data);
    return res.data.contracts;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseContractPage, {
    ref_key: "basePage",
    ref: basePage,
    hasCheckbox: "",
    contractGetAPI: contractGetAPI,
    cols: cols.value,
    seMarketEnable: true
  }, {
    "header-extra": _withCtx(() => [
      _createVNode(HireAgreementPopUp, {
        modelValue: secondaryTableData.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((secondaryTableData).value = $event))
      }, null, 8, ["modelValue"])
    ]),
    "hireAgreement-header": _withCtx(() => [
      _createTextVNode(" Backbook Confirmation ")
    ]),
    backbookConfirmation: _withCtx(({value}) => [
      (value.backbookConfirmation)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "fake-link",
            onClick: e=>value.hasFileData?(()=>{basePage.value?.viewPdf(value.contractID, 'BackbookConfirmation');e.stopPropagation()})():undefined
          }, [
            _createVNode(PdfDownloadSign)
          ], 8, _hoisted_1))
        : (_openBlock(), _createElementBlock("div", _hoisted_2))
    ]),
    orderConfirmation: _withCtx(({value}) => [
      (value.orderConfirmation)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "fake-link",
            onClick: e=>value.hasFileData?(()=>{basePage.value?.viewPdf(value.contractID, 'OrderConf');e.stopPropagation()})():undefined
          }, [
            _createVNode(PdfDownloadSign)
          ], 8, _hoisted_3))
        : (_openBlock(), _createElementBlock("div", _hoisted_4))
    ]),
    orderChange: _withCtx(({value}) => [
      (value.orderChange)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "fake-link",
            onClick: e=>value.hasFileData?(()=>{basePage.value?.viewPdf(value.contractID, 'OrderChange');e.stopPropagation()})():undefined
          }, [
            _createVNode(PdfDownloadSign)
          ], 8, _hoisted_5))
        : (_openBlock(), _createElementBlock("div", _hoisted_6))
    ]),
    contractChange: _withCtx(({value}) => [
      (value.contractChange)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "fake-link",
            onClick: e=>value.hasFileData?(()=>{basePage.value?.viewPdf(value.contractID, 'ContractChange');e.stopPropagation()})():undefined
          }, [
            _createVNode(PdfDownloadSign)
          ], 8, _hoisted_7))
        : (_openBlock(), _createElementBlock("div", _hoisted_8))
    ]),
    "t&CConsented": _withCtx(({ value }) => [
      _createElementVNode("div", _hoisted_9, [
        (value.customerTermsConsentData.length > 0)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "tableDisplayButton",
              onClick: ($event: any) => (displayTablePopUp(value.customerTermsConsentData))
            }, " Display Table ", 8, _hoisted_10))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["cols"]))
}
}

})